/* Generated by ai2react v0.102.0 - 2021-09-14 03:28 */
/* ai file: 04-qs-latam.ai */

import { makeAi2React } from './src/index'
import img0 from './img/04-qs-latam-large.svg'
import img1 from './img/04-qs-latam-mobile.svg'

const styles = `
  #g-04-qs-latam-box ,
  #g-04-qs-latam-box .g-artboard {
    margin:0 auto;
  }
  #g-04-qs-latam-box p {
    margin:0;
  }
  #g-04-qs-latam-box .g-aiAbs {
    position:absolute;
  }
  #g-04-qs-latam-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-04-qs-latam-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-04-qs-latam-box .g-aiPointText p { white-space: nowrap; }
  #g-04-qs-latam-large {
    position:relative;
    overflow:hidden;
  }
  #g-04-qs-latam-large p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-04-qs-latam-large .g-pstyle0 {
    font-weight:800;
    line-height:31px;
    height:31px;
    letter-spacing:-0.02em;
    font-size:26px;
  }
  #g-04-qs-latam-large .g-pstyle1 {
    font-weight:700;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    color:rgb(252,184,19);
  }
  #g-04-qs-latam-large .g-pstyle2 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-04-qs-latam-large .g-pstyle3 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.02em;
    font-size:8px;
  }
  #g-04-qs-latam-large .g-pstyle4 {
    font-weight:700;
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-04-qs-latam-large .g-pstyle5 {
    height:12px;
  }
  #g-04-qs-latam-large .g-pstyle6 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-04-qs-latam-large .g-pstyle7 {
    line-height:11px;
    height:11px;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-04-qs-latam-large .g-pstyle8 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-04-qs-latam-large .g-pstyle9 {
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-04-qs-latam-large .g-pstyle10 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-04-qs-latam-large .g-pstyle11 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-04-qs-latam-large .g-pstyle12 {
    line-height:13px;
    height:13px;
    font-size:11px;
  }
  #g-04-qs-latam-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-04-qs-latam-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-04-qs-latam-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-04-qs-latam-large .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-04-qs-latam-large .g-cstyle4 {
    letter-spacing:-0.033em;
  }
  #g-04-qs-latam-large .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-04-qs-latam-large .g-cstyle6 {
    letter-spacing:-0.034em;
  }
  #g-04-qs-latam-large .g-cstyle7 {
    letter-spacing:-0.086em;
  }
  #g-04-qs-latam-large .g-cstyle8 {
    letter-spacing:-0.116em;
  }
  #g-04-qs-latam-large .g-cstyle9 {
    letter-spacing:-0.054em;
  }
  #g-04-qs-latam-large .g-cstyle10 {
    letter-spacing:-0.04em;
  }
  #g-04-qs-latam-large .g-cstyle11 {
    letter-spacing:-0.036em;
  }
  #g-04-qs-latam-large .g-cstyle12 {
    letter-spacing:-0.032em;
  }
  #g-04-qs-latam-large .g-cstyle13 {
    letter-spacing:-0.035em;
  }
  #g-04-qs-latam-large .g-cstyle14 {
    letter-spacing:-0.044em;
  }
  #g-04-qs-latam-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-04-qs-latam-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-04-qs-latam-mobile .g-pstyle0 {
    font-weight:800;
    line-height:29px;
    height:29px;
    letter-spacing:-0.02em;
    font-size:24px;
  }
  #g-04-qs-latam-mobile .g-pstyle1 {
    font-weight:700;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    color:rgb(252,184,19);
  }
  #g-04-qs-latam-mobile .g-pstyle2 {
    font-weight:700;
    line-height:11px;
    height:11px;
    letter-spacing:-0.02em;
    font-size:9px;
  }
  #g-04-qs-latam-mobile .g-pstyle3 {
    height:12px;
  }
  #g-04-qs-latam-mobile .g-pstyle4 {
    line-height:11px;
    height:11px;
    font-size:9px;
  }
  #g-04-qs-latam-mobile .g-pstyle5 {
    line-height:11px;
    height:11px;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-04-qs-latam-mobile .g-pstyle6 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
    color:rgb(255,255,255);
  }
  #g-04-qs-latam-mobile .g-pstyle7 {
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-04-qs-latam-mobile .g-pstyle8 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
  }
  #g-04-qs-latam-mobile .g-pstyle9 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-04-qs-latam-mobile .g-pstyle10 {
    line-height:13px;
    height:13px;
    font-size:11px;
  }
  #g-04-qs-latam-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-04-qs-latam-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-04-qs-latam-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-04-qs-latam-mobile .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-04-qs-latam-mobile .g-cstyle4 {
    letter-spacing:-0.033em;
  }
  #g-04-qs-latam-mobile .g-cstyle5 {
    letter-spacing:-0.029em;
  }
  #g-04-qs-latam-mobile .g-cstyle6 {
    letter-spacing:-0.034em;
  }
  #g-04-qs-latam-mobile .g-cstyle7 {
    letter-spacing:-0.086em;
  }
  #g-04-qs-latam-mobile .g-cstyle8 {
    letter-spacing:-0.116em;
  }
  #g-04-qs-latam-mobile .g-cstyle9 {
    letter-spacing:-0.04em;
  }
  #g-04-qs-latam-mobile .g-cstyle10 {
    letter-spacing:-0.036em;
  }
  #g-04-qs-latam-mobile .g-cstyle11 {
    letter-spacing:-0.032em;
  }
  #g-04-qs-latam-mobile .g-cstyle12 {
    letter-spacing:-0.035em;
  }
  #g-04-qs-latam-mobile .g-cstyle13 {
    letter-spacing:-0.044em;
  }

`

const html = props => `
<div id="g-04-qs-latam-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-04-qs-latam-large" class="g-artboard" style="width:800px; height:468px;" data-aspect-ratio="1.709" data-min-width="800">
<div style=""></div>
    <img id="g-04-qs-latam-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.1401%;margin-top:-17.7px;left:0.9525%;width:111px;">
      <p class="g-pstyle0"><span class="g-cstyle0">T</span>O<span class="g-cstyle0">P</span> 1<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.9621%;margin-top:-7.3px;left:7.5868%;width:76px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8125%;margin-top:-6.6px;left:1.5145%;width:66px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8765%;margin-top:-5.9px;left:48.3718%;width:39px;">
      <p class="g-pstyle3">P<span class="g-cstyle0">a</span>í<span class="g-cstyle1">s</span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.8765%;margin-top:-5.9px;left:69.1333%;width:54px;">
      <p class="g-pstyle4">Pun<span class="g-cstyle2">ta</span>je<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.7933%;margin-top:-7px;left:9.2393%;width:196px;">
      <p class="g-pstyle5">Po<span class="g-cstyle3">n</span>ti<span class="g-cstyle3">fi</span>c<span class="g-cstyle3">i</span>a <span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> C<span class="g-cstyle4">a</span>tóli<span class="g-cstyle3">ca</span> <span class="g-cstyle3">d</span>e Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.1458%;margin-top:-6.6px;left:42.6677%;width:86px;">
      <p class="g-pstyle6">S<span class="g-cstyle3">an</span>t<span class="g-cstyle3">iago</span>, Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.1458%;margin-top:-6.6px;left:63.7312%;width:40px;">
      <p class="g-pstyle7">1<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.9962%;margin-top:-5.9px;left:4.0646%;width:28px;">
      <p class="g-pstyle8"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4856%;margin-top:-7px;left:9.2393%;width:137px;">
      <p class="g-pstyle9"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span>de <span class="g-cstyle5">S</span>ão<span class="g-cstyle5"> P</span>a<span class="g-cstyle5">u</span>l<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.8381%;margin-top:-6.6px;left:42.6677%;width:92px;">
      <p class="g-pstyle10"><span class="g-cstyle5">S</span>ão<span class="g-cstyle5"> </span>Pa<span class="g-cstyle5">u</span>lo<span class="g-cstyle5">, Br</span>as<span class="g-cstyle5">i</span>l<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.8381%;margin-top:-6.6px;left:63.4039%;width:43px;">
      <p class="g-pstyle7">9<span class="g-cstyle6">8</span>,8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.6885%;margin-top:-5.9px;left:4.0398%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.9642%;margin-top:-7px;left:9.2393%;width:115px;">
      <p class="g-pstyle9"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span>de <span class="g-cstyle5">Ch</span>i<span class="g-cstyle5">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.3167%;margin-top:-6.6px;left:42.6677%;width:86px;">
      <p class="g-pstyle6">S<span class="g-cstyle3">an</span>t<span class="g-cstyle3">iago</span>, Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.3167%;margin-top:-6.6px;left:63.5715%;width:42px;">
      <p class="g-pstyle7">9<span class="g-cstyle7">7</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.1671%;margin-top:-5.9px;left:4.048%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.6565%;margin-top:-7px;left:9.2393%;width:140px;">
      <p class="g-pstyle9"><span class="g-cstyle8">T</span>ec<span class="g-cstyle5">no</span>l<span class="g-cstyle5">ó</span>gic<span class="g-cstyle5">o </span>de<span class="g-cstyle5"> </span>M<span class="g-cstyle5">o</span>n<span class="g-cstyle5">t</span>e<span class="g-cstyle5">r</span><span class="g-cstyle4">r</span><span class="g-cstyle5">e</span>y<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.009%;margin-top:-6.6px;left:42.6677%;width:101px;">
      <p class="g-pstyle6"><span class="g-cstyle3">M</span>o<span class="g-cstyle3">n</span>ter<span class="g-cstyle4">r</span>e<span class="g-cstyle9">y</span>, <span class="g-cstyle3">Méx</span>i<span class="g-cstyle3">c</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.009%;margin-top:-6.6px;left:63.42%;width:43px;">
      <p class="g-pstyle7">96<span class="g-cstyle10">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.8594%;margin-top:-5.9px;left:4.0149%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.1352%;margin-top:-7px;left:9.2393%;width:136px;">
      <p class="g-pstyle9"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span>de <span class="g-cstyle5">lo</span>s<span class="g-cstyle5"> An</span>d<span class="g-cstyle5">e</span>s<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.4877%;margin-top:-6.6px;left:42.6677%;width:97px;">
      <p class="g-pstyle10"><span class="g-cstyle5">B</span>o<span class="g-cstyle5">g</span>ot<span class="g-cstyle5">á</span>,<span class="g-cstyle5"> C</span>ol<span class="g-cstyle5">omb</span>ia<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.4877%;margin-top:-6.6px;left:63.5211%;width:42px;">
      <p class="g-pstyle7">9<span class="g-cstyle3">5</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.5517%;margin-top:-5.9px;left:4.048%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.8275%;margin-top:-7px;left:9.2393%;width:214px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">N</span>a<span class="g-cstyle3">c</span>i<span class="g-cstyle3">o</span>n<span class="g-cstyle3">a</span>l Autónom<span class="g-cstyle3">a</span> de M<span class="g-cstyle3">éx</span>i<span class="g-cstyle3">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.18%;margin-top:-6.6px;left:42.6677%;width:133px;">
      <p class="g-pstyle6">C<span class="g-cstyle3">i</span>u<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> M</span>éx<span class="g-cstyle3">i</span>c<span class="g-cstyle3">o</span>, <span class="g-cstyle3">M</span>éx<span class="g-cstyle3">i</span>co<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.18%;margin-top:-6.6px;left:63.4292%;width:43px;">
      <p class="g-pstyle7">9<span class="g-cstyle11">4</span>,<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.0304%;margin-top:-5.9px;left:4.0315%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.3061%;margin-top:-7px;left:9.2393%;width:177px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">Esta</span>dual d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">a</span>mp<span class="g-cstyle3">i</span>na<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.6586%;margin-top:-6.6px;left:42.6677%;width:92px;">
      <p class="g-pstyle6">C<span class="g-cstyle3">a</span>mpi<span class="g-cstyle3">na</span>s<span class="g-cstyle3">,</span> B<span class="g-cstyle3">ra</span>s<span class="g-cstyle3">i</span>l<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.6586%;margin-top:-6.6px;left:63.4625%;width:43px;">
      <p class="g-pstyle7">9<span class="g-cstyle6">3</span><span class="g-cstyle10">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.509%;margin-top:-5.9px;left:4.0563%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.9984%;margin-top:-7px;left:9.2393%;width:151px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">de </span>Buen<span class="g-cstyle3">os</span> Ai<span class="g-cstyle4">r</span>es<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.3509%;margin-top:-6.6px;left:42.6677%;width:122px;">
      <p class="g-pstyle6">Buen<span class="g-cstyle3">o</span>s<span class="g-cstyle3"> </span>Ai<span class="g-cstyle4">r</span>es, A<span class="g-cstyle3">r</span>genti<span class="g-cstyle3">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.3509%;margin-top:-6.6px;left:63.505%;width:42px;">
      <p class="g-pstyle11"><span class="g-cstyle5">9</span>2<span class="g-cstyle5">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.2013%;margin-top:-5.9px;left:4.0315%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.4771%;margin-top:-7px;left:9.2393%;width:191px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">F</span>e<span class="g-cstyle3">de</span>r<span class="g-cstyle3">a</span>l <span class="g-cstyle3">d</span>e Río d<span class="g-cstyle3">e </span>Ja<span class="g-cstyle3">n</span>e<span class="g-cstyle3">i</span><span class="g-cstyle12">r</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.8296%;margin-top:-6.6px;left:42.6677%;width:109px;">
      <p class="g-pstyle6">R<span class="g-cstyle3">ío</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Ja<span class="g-cstyle3">n</span>ei<span class="g-cstyle4">r</span><span class="g-cstyle3">o</span>, B<span class="g-cstyle3">ra</span>s<span class="g-cstyle3">i</span>l<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.8296%;margin-top:-6.6px;left:63.4625%;width:42px;">
      <p class="g-pstyle7">91<span class="g-cstyle11">,</span><span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.68%;margin-top:-5.9px;left:4.0315%;width:29px;">
      <p class="g-pstyle8"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.1694%;margin-top:-7px;left:9.2393%;width:173px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">N</span>a<span class="g-cstyle3">c</span>i<span class="g-cstyle3">o</span>n<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> Co<span class="g-cstyle3">l</span>o<span class="g-cstyle3">m</span>bi<span class="g-cstyle1">a</span></p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.5219%;margin-top:-6.6px;left:42.6677%;width:95px;">
      <p class="g-pstyle6">B<span class="g-cstyle3">o</span>g<span class="g-cstyle3">ot</span>á<span class="g-cstyle3">,</span> C<span class="g-cstyle3">ol</span>omb<span class="g-cstyle3">i</span><span class="g-cstyle1">a</span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.5219%;margin-top:-6.6px;left:63.3959%;width:41px;">
      <p class="g-pstyle7">86<span class="g-cstyle3">,</span><span class="g-cstyle1">8</span></p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3723%;margin-top:-5.9px;left:3.7383%;width:31px;">
      <p class="g-pstyle8"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:95.1502%;margin-top:-7.3px;left:0.9441%;width:195px;">
      <p class="g-pstyle12">(<span class="g-cstyle3">*</span>) <span class="g-cstyle13">F</span>u<span class="g-cstyle3">e</span>n<span class="g-cstyle3">te</span>: ww<span class="g-cstyle14">w</span><span class="g-cstyle13">.</span>t<span class="g-cstyle3">o</span>pu<span class="g-cstyle3">nive</span>r<span class="g-cstyle3">s</span>iti<span class="g-cstyle3">es</span>.<span class="g-cstyle3">c</span>o<span class="g-cstyle1">m</span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-04-qs-latam-mobile" class="g-artboard" style="max-width: 320px;max-height: 460px" data-aspect-ratio="0.696" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 143.75% 0;"></div>
    <img id="g-04-qs-latam-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:5.7901%;margin-top:-16.6px;left:1.1298%;width:104px;">
      <p class="g-pstyle0"><span class="g-cstyle0">T</span>O<span class="g-cstyle0">P</span> 1<span class="g-cstyle1">0</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.1459%;margin-top:-7.3px;left:19.6452%;width:75px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.2118%;margin-top:-6.6px;left:2.5291%;width:66px;">
      <p class="g-pstyle2">RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>G<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.2118%;margin-top:-6.6px;left:44.6802%;width:41px;">
      <p class="g-pstyle2">País</p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:11.2118%;margin-top:-6.6px;left:70.1816%;width:58px;">
      <p class="g-pstyle2">Puntaje </p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.4369%;margin-top:-12.8px;left:11.6898%;width:117px;">
      <p class="g-pstyle3">Po<span class="g-cstyle3">n</span>ti<span class="g-cstyle3">fi</span>c<span class="g-cstyle3">i</span>a <span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span></p>
      <p class="g-pstyle3">C<span class="g-cstyle4">a</span>tóli<span class="g-cstyle3">ca</span> <span class="g-cstyle3">d</span>e Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.8205%;margin-top:-6.6px;left:56.9693%;width:45px;">
      <p class="g-pstyle4">Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.8205%;margin-top:-6.6px;left:72.8317%;width:39px;">
      <p class="g-pstyle5">1<span class="g-cstyle3">0</span>0<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:18.6691%;margin-top:-5.9px;left:5.186%;width:28px;">
      <p class="g-pstyle6"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.6108%;margin-top:-12.8px;left:11.6898%;width:90px;">
      <p class="g-pstyle7"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span>de </p>
      <p class="g-pstyle3">S<span class="g-cstyle3">ão</span> P<span class="g-cstyle3">a</span>u<span class="g-cstyle3">l</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4292%;margin-top:-6.6px;left:56.9693%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle5">Br</span>as<span class="g-cstyle5">i</span>l<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.4292%;margin-top:-6.6px;left:72.0178%;width:43px;">
      <p class="g-pstyle5">9<span class="g-cstyle6">8</span>,8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:26.2778%;margin-top:-5.9px;left:5.1241%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.2195%;margin-top:-12.8px;left:11.6898%;width:77px;">
      <p class="g-pstyle7"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span></p>
      <p class="g-pstyle7">de <span class="g-cstyle5">Ch</span>i<span class="g-cstyle5">l</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.0379%;margin-top:-6.6px;left:56.9693%;width:45px;">
      <p class="g-pstyle4">Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.0379%;margin-top:-6.6px;left:72.4347%;width:42px;">
      <p class="g-pstyle5">9<span class="g-cstyle7">7</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:33.8865%;margin-top:-5.9px;left:5.1443%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.0456%;margin-top:-12.8px;left:11.6898%;width:84px;">
      <p class="g-pstyle7"><span class="g-cstyle8">T</span>ec<span class="g-cstyle5">no</span>l<span class="g-cstyle5">ó</span>gic<span class="g-cstyle5">o </span></p>
      <p class="g-pstyle7">de<span class="g-cstyle5"> </span>M<span class="g-cstyle5">o</span>n<span class="g-cstyle5">t</span>e<span class="g-cstyle5">r</span><span class="g-cstyle4">r</span><span class="g-cstyle5">e</span>y<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.864%;margin-top:-6.6px;left:56.9693%;width:54px;">
      <p class="g-pstyle8">Méx<span class="g-cstyle5">i</span>c<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.864%;margin-top:-6.6px;left:72.0578%;width:43px;">
      <p class="g-pstyle5">96<span class="g-cstyle9">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.7125%;margin-top:-5.9px;left:5.0623%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.8716%;margin-top:-12.8px;left:11.6898%;width:81px;">
      <p class="g-pstyle7"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span></p>
      <p class="g-pstyle3"><span class="g-cstyle3">de </span>lo<span class="g-cstyle3">s</span> An<span class="g-cstyle3">d</span>e<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.4727%;margin-top:-6.6px;left:56.9693%;width:63px;">
      <p class="g-pstyle8"><span class="g-cstyle5">C</span>ol<span class="g-cstyle5">omb</span>ia<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.4727%;margin-top:-6.6px;left:72.3093%;width:42px;">
      <p class="g-pstyle5">9<span class="g-cstyle3">5</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:49.3212%;margin-top:-5.9px;left:5.1443%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.4803%;margin-top:-12.8px;left:11.6898%;width:118px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">N</span>a<span class="g-cstyle3">c</span>i<span class="g-cstyle3">o</span>n<span class="g-cstyle3">a</span>l </p>
      <p class="g-pstyle3">Autónom<span class="g-cstyle3">a</span> de M<span class="g-cstyle3">éx</span>i<span class="g-cstyle3">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.0814%;margin-top:-6.6px;left:56.9693%;width:54px;">
      <p class="g-pstyle4"><span class="g-cstyle3">M</span>éx<span class="g-cstyle3">i</span>co<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:57.0814%;margin-top:-6.6px;left:72.0807%;width:43px;">
      <p class="g-pstyle5">9<span class="g-cstyle10">4</span>,<span class="g-cstyle3">5</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.9299%;margin-top:-5.9px;left:5.1035%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.3064%;margin-top:-12.8px;left:11.6898%;width:116px;">
      <p class="g-pstyle3"><span class="g-cstyle4">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">id</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">Esta</span>dual </p>
      <p class="g-pstyle3">d<span class="g-cstyle3">e</span> C<span class="g-cstyle3">a</span>mp<span class="g-cstyle3">i</span>na<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.9075%;margin-top:-6.6px;left:56.9693%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle5">B</span>ra<span class="g-cstyle5">s</span>i<span class="g-cstyle5">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.9075%;margin-top:-6.6px;left:72.1634%;width:43px;">
      <p class="g-pstyle5">9<span class="g-cstyle6">3</span><span class="g-cstyle9">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:64.756%;margin-top:-5.9px;left:5.1653%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.9151%;margin-top:-12.8px;left:11.6898%;width:90px;">
      <p class="g-pstyle7"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span>de </p>
      <p class="g-pstyle3">Buen<span class="g-cstyle3">os</span> Ai<span class="g-cstyle4">r</span>es<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.5162%;margin-top:-6.6px;left:56.9693%;width:64px;">
      <p class="g-pstyle4">A<span class="g-cstyle3">r</span>genti<span class="g-cstyle3">n</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.5162%;margin-top:-6.6px;left:72.2693%;width:42px;">
      <p class="g-pstyle9"><span class="g-cstyle5">9</span>2<span class="g-cstyle5">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:72.3647%;margin-top:-5.9px;left:5.1035%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.7412%;margin-top:-12.8px;left:11.6898%;width:112px;">
      <p class="g-pstyle7"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span>F<span class="g-cstyle5">e</span>de<span class="g-cstyle5">r</span>a<span class="g-cstyle5">l </span></p>
      <p class="g-pstyle3"><span class="g-cstyle3">d</span>e Río d<span class="g-cstyle3">e </span>Ja<span class="g-cstyle3">n</span>e<span class="g-cstyle3">i</span><span class="g-cstyle11">r</span>o<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.1249%;margin-top:-6.6px;left:56.9693%;width:47px;">
      <p class="g-pstyle8"><span class="g-cstyle5">B</span>ra<span class="g-cstyle5">s</span>i<span class="g-cstyle5">l</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.1249%;margin-top:-6.6px;left:72.1634%;width:42px;">
      <p class="g-pstyle5">91<span class="g-cstyle10">,</span><span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:79.9734%;margin-top:-5.9px;left:5.1035%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.3499%;margin-top:-12.8px;left:11.6898%;width:118px;">
      <p class="g-pstyle7"><span class="g-cstyle4">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>id<span class="g-cstyle5">a</span>d<span class="g-cstyle5"> </span></p>
      <p class="g-pstyle3"><span class="g-cstyle3">N</span>a<span class="g-cstyle3">c</span>i<span class="g-cstyle3">o</span>n<span class="g-cstyle3">a</span>l d<span class="g-cstyle3">e</span> Co<span class="g-cstyle3">l</span>o<span class="g-cstyle3">m</span>bi<span class="g-cstyle1">a</span></p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.951%;margin-top:-6.6px;left:56.9693%;width:61px;">
      <p class="g-pstyle4">C<span class="g-cstyle3">ol</span>omb<span class="g-cstyle3">i</span><span class="g-cstyle1">a</span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.951%;margin-top:-6.6px;left:71.998%;width:41px;">
      <p class="g-pstyle5">86<span class="g-cstyle3">,</span><span class="g-cstyle1">8</span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.7995%;margin-top:-5.9px;left:4.3742%;width:31px;">
      <p class="g-pstyle6"><span class="g-cstyle0">1</span>0</p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:95.2764%;margin-top:-7.3px;left:2.3604%;width:195px;">
      <p class="g-pstyle10">(<span class="g-cstyle3">*</span>) <span class="g-cstyle12">F</span>u<span class="g-cstyle3">e</span>n<span class="g-cstyle3">te</span>: ww<span class="g-cstyle13">w</span><span class="g-cstyle12">.</span>t<span class="g-cstyle3">o</span>pu<span class="g-cstyle3">nive</span>r<span class="g-cstyle3">s</span>iti<span class="g-cstyle3">es</span>.<span class="g-cstyle3">c</span>o<span class="g-cstyle1">m</span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-04-qs-latam-box'
const namespace = 'g-'
const name = '04-qs-latam'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 03:28 */
